import React, { useState, useEffect } from 'react';
import { useUser } from '../App';
import './Admin.css';

const getInitData = () => {
    return window.Telegram?.WebApp?.initData;
}

const Admin = () => {
  const user = useUser();
  const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
  const [filter, setFilter] = useState('all'); // 'all', 'paid', 'active', 'with_keys', 'failed'
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedUser, setSelectedUser] = useState(null);
  const [userDetails, setUserDetails] = useState(null);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [keyCreateModal, setKeyCreateModal] = useState(null);
  const [keyCreating, setKeyCreating] = useState(false);

    useEffect(() => {
    const fetchLogs = async () => {
        const initData = getInitData();
        if (!initData) {
        setError("Ошибка аутентификации");
          setLoading(false);
          return;
        }
      
        try {
        const response = await fetch('/api/admin/user-activity', {
          headers: { 'init-data': initData }
          });
        if (!response.ok) throw new Error(`Ошибка: ${response.status}`);
          const data = await response.json();
        setLogs(data);
        } catch (e) {
          setError(e.message);
        } finally {
          setLoading(false);
        }
      };
    
    fetchLogs();
    }, []);

  const getFilteredLogs = () => {
    let filtered = logs;
    
    // Фильтрация по типу
    switch (filter) {
      case 'paid':
        filtered = filtered.filter(log => log.successful_payments > 0);
        break;
      case 'active':
        filtered = filtered.filter(log => log.has_active_subscription);
        break;
      case 'with_keys':
        filtered = filtered.filter(log => log.total_keys > 0);
        break;
      case 'no_keys':
        filtered = filtered.filter(log => log.successful_payments > 0 && log.total_keys === 0);
        break;
      case 'failed':
        filtered = filtered.filter(log => log.failed_payments > 0);
        break;
      default:
        break;
    }
    
    // Поиск по Telegram ID
    if (searchTerm) {
      filtered = filtered.filter(log => 
        log.telegram_id.toString().includes(searchTerm)
      );
    }
    
    return filtered;
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '—';
    return new Date(dateStr).toLocaleString('ru-RU', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getStatusBadge = (log) => {
    if (log.has_active_subscription && log.total_keys > 0) {
      return <span className="badge badge-success">✓ Активен</span>;
    }
    if (log.successful_payments > 0 && log.total_keys === 0) {
      return <span className="badge badge-warning">⚠ Оплатил, нет ключа</span>;
    }
    if (log.failed_payments > 0) {
      return <span className="badge badge-error">✗ Ошибка оплаты</span>;
    }
    return <span className="badge badge-default">Новый</span>;
  };

  const handleUserClick = async (telegram_id) => {
        const initData = getInitData();
    if (!initData) return;
    
    setSelectedUser(telegram_id);
    setDetailsLoading(true);
    
    try {
      const response = await fetch(`/api/admin/user-details/${telegram_id}`, {
        headers: { 'init-data': initData }
      });
      if (!response.ok) throw new Error('Ошибка загрузки');
      const data = await response.json();
      setUserDetails(data);
    } catch (e) {
      alert('Ошибка при загрузке деталей: ' + e.message);
      setSelectedUser(null);
    } finally {
      setDetailsLoading(false);
    }
  };

  const closeModal = () => {
    setSelectedUser(null);
    setUserDetails(null);
  };

  const handleCreateKey = async (telegram_id, e) => {
    e.stopPropagation(); // Предотвращаем открытие модального окна деталей
    setKeyCreateModal(telegram_id);
  };

  const confirmCreateKey = async () => {
    if (!keyCreateModal) return;
    
    const initData = getInitData();
    if (!initData) {
      alert('Ошибка аутентификации');
      return;
    }

    setKeyCreating(true);
    try {
      const response = await fetch(`/api/admin/create-key-for-payment/${keyCreateModal}`, {
        method: 'POST',
        headers: { 'init-data': initData }
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ detail: 'Ошибка сервера' }));
        throw new Error(errorData.detail || `Ошибка: ${response.status}`);
      }

      const result = await response.json();
      
      if (result.status === 'exists') {
        alert('⚠ Ключ уже существует для этого платежа');
      } else {
        alert('✅ Ключ успешно создан!');
        // Обновляем список пользователей
        const logsResponse = await fetch('/api/admin/user-activity', {
          headers: { 'init-data': initData }
        });
        if (logsResponse.ok) {
          const updatedLogs = await logsResponse.json();
          setLogs(updatedLogs);
        }
      }
      
      setKeyCreateModal(null);
    } catch (e) {
      alert('Ошибка при создании ключа: ' + e.message);
    } finally {
      setKeyCreating(false);
    }
  };

  const cancelCreateKey = () => {
    setKeyCreateModal(null);
  };

  if (!user?.is_admin) {
    return <div className="page-container">Доступ запрещен</div>;
  }

  if (loading) {
    return <div className="page-container admin-page">Загрузка...</div>;
  }

  if (error) {
    return <div className="page-container admin-page">Ошибка: {error}</div>;
  }

  const filteredLogs = getFilteredLogs();

    return (
    <div className="page-container admin-page" style={{paddingTop: '60px'}}>
      <h1 className="page-title">📊 Логирование пользователей</h1>
      
      <div className="admin-controls">
        <div className="search-box">
          <input
            type="text"
            placeholder="🔍 Поиск по Telegram ID..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
        </div>
        
        <div className="filter-buttons">
          <button onClick={() => setFilter('all')} className={filter === 'all' ? 'active' : ''}>
            Все ({logs.length})
          </button>
          <button onClick={() => setFilter('active')} className={filter === 'active' ? 'active' : ''}>
            Активные ({logs.filter(l => l.has_active_subscription).length})
          </button>
          <button onClick={() => setFilter('paid')} className={filter === 'paid' ? 'active' : ''}>
            Оплатили ({logs.filter(l => l.successful_payments > 0).length})
          </button>
          <button onClick={() => setFilter('with_keys')} className={filter === 'with_keys' ? 'active' : ''}>
            С ключами ({logs.filter(l => l.total_keys > 0).length})
          </button>
          <button onClick={() => setFilter('no_keys')} className={filter === 'no_keys' ? 'active' : ''}>
            Без ключей ({logs.filter(l => l.successful_payments > 0 && l.total_keys === 0).length})
          </button>
          <button onClick={() => setFilter('failed')} className={filter === 'failed' ? 'active' : ''}>
            Ошибки ({logs.filter(l => l.failed_payments > 0).length})
          </button>
        </div>
      </div>

      <div className="stats-summary">
        <div className="stat-card">
          <div className="stat-value">{logs.length}</div>
          <div className="stat-label">Всего пользователей</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">{logs.filter(l => l.successful_payments > 0).length}</div>
          <div className="stat-label">Оплатили</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">{logs.reduce((sum, l) => sum + l.total_keys, 0)}</div>
          <div className="stat-label">Ключей создано</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">{logs.reduce((sum, l) => sum + l.successful_payments, 0)}</div>
          <div className="stat-label">Успешных платежей</div>
        </div>
      </div>

      <div className="logs-table-container">
        <table className="logs-table">
          <thead>
            <tr>
              <th>Telegram ID</th>
              <th>Статус</th>
              <th>Платежей</th>
              <th>Успешно</th>
              <th>Ошибок</th>
              <th>Ключей</th>
              <th>Последний платеж</th>
              <th>Сумма</th>
              <th>Действия</th>
            </tr>
          </thead>
          <tbody>
            {filteredLogs.length === 0 ? (
              <tr>
                <td colSpan="9" className="empty-message">Нет данных</td>
              </tr>
            ) : (
              filteredLogs.map((log) => (
                <tr key={log.user_id} onClick={() => handleUserClick(log.telegram_id)} className="clickable-row">
                  <td><strong>{log.telegram_id}</strong></td>
                  <td>{getStatusBadge(log)}</td>
                  <td>{log.total_payments}</td>
                  <td className="success-text">{log.successful_payments}</td>
                  <td className="error-text">{log.failed_payments}</td>
                  <td className="keys-cell">{log.total_keys > 0 ? `✓ ${log.total_keys}` : '—'}</td>
                  <td>{formatDate(log.last_payment_date)}</td>
                  <td>{log.last_payment_amount ? `${log.last_payment_amount} ₽` : '—'}</td>
                  <td onClick={(e) => e.stopPropagation()} className="actions-cell">
                    {log.successful_payments > 0 && log.total_keys === 0 ? (
                      <button 
                        className="create-key-btn"
                        onClick={(e) => handleCreateKey(log.telegram_id, e)}
                        title="Создать ключ на основе последнего платежа"
                      >
                        🔑 Создать ключ
                      </button>
                    ) : (
                      <span className="no-action-text">—</span>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {selectedUser && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>✕</button>
            
            <h2 className="modal-title">📋 Детальная информация</h2>
            
            {detailsLoading ? (
              <div className="modal-loading">Загрузка...</div>
            ) : userDetails ? (
              <div className="details-content">
                <div className="user-header-section">
                  {userDetails.photo_url && (
                    <img 
                      src={userDetails.photo_url} 
                      alt="User avatar" 
                      className="user-avatar"
                      onError={(e) => { e.target.style.display = 'none'; }}
                    />
                  )}
                  <div className="user-header-info">
                    <h3 className="user-name">
                      {userDetails.first_name || ''} {userDetails.last_name || ''}
                      {!userDetails.first_name && !userDetails.last_name && 'Пользователь Telegram'}
                    </h3>
                    {userDetails.username && (
                      <div className="user-username">@{userDetails.username}</div>
                    )}
                    <div className="user-telegram-id">ID: {selectedUser}</div>
                  </div>
                </div>
                
                <div className="details-section">
                  <h3>👤 Информация о пользователе</h3>
                  <div className="detail-item">
                    <span className="detail-label">Статус подписки:</span>
                    <span className={userDetails.has_active_subscription ? "detail-value success" : "detail-value"}>
                      {userDetails.has_active_subscription ? '✓ Активна' : '✗ Неактивна'}
                    </span>
                  </div>
                  {userDetails.subscription_end_date && (
                    <div className="detail-item">
                      <span className="detail-label">Подписка до:</span>
                      <span className="detail-value">{formatDate(userDetails.subscription_end_date)}</span>
                    </div>
                  )}
                  <div className="detail-item">
                    <span className="detail-label">Бонусный баланс:</span>
                    <span className="detail-value">{userDetails.bonus_balance} ₽</span>
                  </div>
                </div>

                <div className="details-section">
                  <h3>💰 История платежей ({userDetails.payments.length})</h3>
                  {userDetails.payments.length === 0 ? (
                    <p className="empty-text">Платежей нет</p>
                  ) : (
                    <div className="timeline">
                      {userDetails.payments.map((payment) => (
                        <div key={payment.payment_id} className="timeline-item">
                          <div className="timeline-marker"></div>
                          <div className="timeline-content">
                            <div className="timeline-header">
                              <span className={`payment-status ${payment.status}`}>
                                {payment.status === 'succeeded' ? '✓' : payment.status === 'pending' ? '⏳' : '✗'} 
                                {payment.status === 'succeeded' ? 'Успешно' : payment.status === 'pending' ? 'В обработке' : 'Ошибка'}
                              </span>
                              <span className="timeline-date">{formatDate(payment.created_at)}</span>
                            </div>
                            <div className="timeline-body">
                              <p><strong>Оплатил:</strong> {payment.amount} ₽ за тариф "{payment.tariff_name}"</p>
                              {payment.bonuses_spent > 0 && (
                                <p><strong>Использовано бонусов:</strong> {payment.bonuses_spent} ₽</p>
                              )}
                              {payment.status === 'succeeded' && (
                                <p className={payment.key_created ? "success-text" : "error-text"}>
                                  {payment.key_created ? 
                                    `✓ Ключ создан (ID: ${payment.key_id}), отобразился в кабинете` : 
                                    '✗ Ключ НЕ был создан (проблема!)'}
                                </p>
                              )}
                            </div>
                    </div>
                </div>
            ))}
        </div>
                  )}
      </div>

                <div className="details-section">
                  <h3>🔑 Ключи ({userDetails.keys.length})</h3>
                  {userDetails.keys.length === 0 ? (
                    <p className="empty-text">Ключей нет</p>
                  ) : (
                    <div className="keys-list-detail">
                      {userDetails.keys.map((key) => (
                        <div key={key.key_id} className="key-item">
                          <div className="key-header">
                            <span className="key-id">Ключ #{key.key_id}</span>
                            <span className={`key-status ${key.is_expired ? 'expired' : 'active'}`}>
                              {key.is_expired ? '✗ Истёк' : '✓ Активен'}
                            </span>
                          </div>
                          <div className="key-info">
                            <p><strong>Создан:</strong> {formatDate(key.created_at)}</p>
                            <p><strong>Действителен до:</strong> {formatDate(key.expiration_date)}</p>
                            <p><strong>Marzban:</strong> {key.marzban_username}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <div className="modal-error">Ошибка загрузки данных</div>
            )}
      </div>
        </div>
      )}

      {/* Модальное окно подтверждения создания ключа */}
      {keyCreateModal && (
        <div className="modal-overlay" onClick={cancelCreateKey}>
          <div className="modal-content confirm-modal" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={cancelCreateKey}>✕</button>
            
            <h2 className="modal-title">🔑 Создание ключа</h2>
            <div className="modal-subtitle">Telegram ID: <strong>{keyCreateModal}</strong></div>
            
            <div className="confirm-content">
              <p>Вы уверены, что хотите создать ключ для этого пользователя?</p>
              <p className="confirm-hint">
                Ключ будет создан на основе последнего успешного платежа пользователя.
              </p>
              
              <div className="confirm-buttons">
                <button 
                  className="confirm-btn confirm-yes" 
                  onClick={confirmCreateKey}
                  disabled={keyCreating}
                >
                  {keyCreating ? 'Создание...' : '✅ Да, создать'}
                </button>
                <button 
                  className="confirm-btn confirm-no" 
                  onClick={cancelCreateKey}
                  disabled={keyCreating}
                >
                  Отмена
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Admin; 
